<template>
  <div class="image-upload" :class="classes">
    <input
      type="file"
      class="visually-hidden"
      :accept="formatsString"
      ref="input"
      :disabled="disabled"
      @change="onFileChange($event)"
    />

    <slot v-bind="{ file, imageSrc, chooseImage }" />
  </div>
</template>

<script>
import { fileSizes, formatBytes } from "@utils/files";
import { ext, size } from "@utils/validators";
import { getValidationMessage } from "@utils/validation-messages";

export default {
  name: "ImageUpload",

  props: {
    maxSize: {
      default: (fileSizes.MB / 1024) * 2
    },
    disabled: Boolean
  },

  data: () => ({
    formats: ["png", "jpg"],
    file: null,
    result: null,
    preview: null
  }),

  validations() {
    return {
      file: {
        size: size(this.maxSize),
        ext: ext(this.formats)
      }
    };
  },

  computed: {
    classes() {
      return {
        "is-disabled": this.disabled
      };
    },
    imageSrc() {
      return this.preview;
    },
    fileSizeString() {
      return formatBytes(this.maxSize * 1024);
    },
    formatsString() {
      return this.formats.join(", ");
    }
  },

  methods: {
    chooseImage() {
      if (this.disabled) return;
      this.$refs.input.click();
    },

    reset() {
      this.preview = null;
      this.file = null;
      this.result = null;
      this.$v.$reset();
    },

    isInvalid(field) {
      return !this.$v.file[field];
    },

    async onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.file = file;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$emit("error", getValidationMessage(this.$v.file));
        return;
      }

      this.result = file;

      const reader = new FileReader();

      reader.onload = () => {
        this.preview = reader.result;
        this.$emit("change", file);
      };

      reader.readAsDataURL(event.target.files[0]);
    }
  }
};
</script>

<style lang="scss">
.image-upload {
  cursor: pointer;
  &__input {
    appearance: none;
    width: 100%;
    height: 100;
  }

  &.is-disabled {
    cursor: default;
  }
}
</style>
